import { DatePicker, Divider, Select, message } from "antd";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  documentAccpetedTypes,
  documentWidget,
  iDocumentStages,
} from "../../../utils/constants";
import { useMediaQuery } from "react-responsive";
import { AllowedProfileEditStatus, maxFileSize } from "../../../constants";
import AxiosInstance from "../../../AxiosInstance";
import { uploadProfileDocumentToAWS } from "../../Helper/uploadDocument";
import {
  genderOptions,
  industryTypeOptions,
} from "../../../utils/dropDownOptions";
import VerifyPanModal from "../../../components/Model/VerifyPanModal";

import { Option } from "antd/es/mentions";
import moment from "moment";
import { getEntityBankAccountType } from "../../../utils";
import dayjs from "dayjs";

export default function RegisterAsCompany({ inputProfileData, inputBankList }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    getValues,
    reset,
  } = useForm({ mode: "onChange" });
  const [countries, setCountries] = useState([]);
  const [orgMemoDocument, setOrgMemoDoc] = useState();
  const [orgPanDocument, setorgPanDocument] = useState();
  const [orgRegistrationDocument, setorgRegistrationDocument] = useState();
  const [orgLossDocument, setorgLossDocument] = useState();
  const [orgIncomeDocument, setorgIncomeDocument] = useState();
  const [orgBalanceSheetDocument, setorgBalanceSheetDocument] = useState();
  const [orgAddressDocument, setorgAddressDocument] = useState();

  const [stateList, setStateList] = useState([]);
  const [bankList, setBankList] = useState(inputBankList);
  const [loading, setLoading] = useState(false);
  const [nomineeDetails, setNomineeDetails] = useState([]);
  const [verifyPanModalState, setVerifyPanModalState] = useState(false);
  const [verifyOrgPanModalState, setVerifyOrgPanModalState] = useState(false);
  const [isPanVerified, setIsPanVerified] = useState(false);
  const [isOrgPanVerified, setIsOrgPanVerified] = useState(false);
  const [verifyAadhaarModalState, setVerifyAadhaarModalState] = useState(false);
  const [isAadhaarVerified, setIsAadhaarVerified] = useState(false);
  const [profileData, setProfileData] = useState(inputProfileData);
  const [isCompany, setIsCompany] = useState(false);

  const isMobile = useMediaQuery({ query: "(max-width: 750px)" });

  const [documentHill, setDocumentHill] = useState({
    orgMemoDocument: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "orgMemoDocument",
    },
    orgPanDocument: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "orgPanDocument",
    },
    orgRegistrationDocument: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "orgRegistrationDocument",
    },
    orgIncomeDocument: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "orgIncomeDocument",
    },
    orgLossDocument: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "orgLossDocument",
    },
    orgBalanceSheetDocument: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "orgBalanceSheetDocument",
    },
    orgAddressDocument: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "orgAddressDocument",
    },
  });
  useEffect(() => {
    console.log("use Effect", documentHill);
  }, [documentHill]);

  useEffect(() => {
    getProfileDataNew();
    // getSpinnerData();
  }, []);
  //   const getSpinnerData = async () => {
  //     const ctn = await countriesListController();
  //     setCountries(ctn);
  //     const bnk = await banksListController();
  //     setBankList(bnk);
  //   };
  const getProfileDataNew = async () => {
    // let profileData = {};
    // const result = await AxiosInstance()
    //   .get(`/user/me`)
    //   .catch((error) => {});
    // profileData = profileData;
    // setProfileData(result.data);

    if (profileData) {
      console.log(profileData);
      if (profileData.isPanVerified && profileData.pan) {
        // pan field will be disable only if pan number is also available
        setValue("pan", profileData.pan);
        setIsPanVerified(true);
      }
      if (profileData.pan) {
        setValue("pan", profileData.pan);
      }
      if (profileData.firstName) {
        setValue("firstName", profileData.firstName);
      }
      if (profileData.lastName) {
        setValue("lastName", profileData.lastName);
      }

      if (profileData.isOrgPanVerified && profileData.orgPan) {
        // pan field will be disable only if org pan number is also available
        setValue("orgPan", profileData.orgPan);
        setIsOrgPanVerified(true);
      }
      if (profileData.orgPan) {
        setValue("orgPan", profileData.orgPan);
      }
      if (profileData.orgRegistrationDate) {
        dateChange("", profileData.orgRegistrationDate);
        setValue("orgRegistrationDate", profileData.orgRegistrationDate);
      }
      if (profileData.isAadhaarVerified && profileData.aadhar) {
        // aadhaar field will be disable only if pan number is also available
        setIsAadhaarVerified(true);
      }
      if (profileData.aadhar) {
        setValue("aadhar", profileData.aadhar);
      }
      if (profileData.gender) setValue("gender", profileData.gender);
      if (profileData.addressOfOrganization)
        setValue("addressOfOrganization", profileData.addressOfOrganization);
      if (profileData.occupation)
        setValue("occupation", profileData.occupation);
      if (profileData.city) setValue("city", profileData.city);
      //   if (profileData.countryId) {
      //     countryChange(profileData.countryId);
      //   }
      if (profileData.stateId) {
        stateChange(profileData.stateId);
      }
      if (profileData.pinCode) setValue("pinCode", profileData.pinCode);
      if (profileData.bankAccountNumber)
        setValue("bankAccountNumber", profileData.bankAccountNumber);
      if (profileData.bankId) {
        bankNameChange(profileData.bankId);
      }
      if (profileData.accountType) {
        accountTypeChange(profileData.accountType);
      }
      if (profileData.IFSCCode) setValue("IFSCCode", profileData.IFSCCode);
      if (profileData.UPICode) setValue("UPICode", profileData.UPICode);
      if (profileData.EIANumber) setValue("EIANumber", profileData.EIANumber);
      if (profileData.nomineeName)
        setValue("nomineeName", profileData.nomineeName);
      if (profileData.maritalStatus)
        setValue("maritalStatus", profileData.maritalStatus);
      if (profileData.annualIncome)
        setValue("annualIncome", parseInt(profileData.annualIncome));
      if (profileData.education) setValue("education", profileData.education);
      if (profileData.nameOfOrganization)
        setValue("nameOfOrganization", profileData.nameOfOrganization);

      if (profileData.jobTitle) setValue("jobTitle", profileData.jobTitle);
      if (profileData.industryType)
        setValue("industryType", profileData.industryType);
    }
  };

  const navigate = useNavigate();
  const onSubmit = async (value) => {
    if (loading) return;
    setLoading(true);
    if (documentHill.orgMemoDocument.status === iDocumentStages.UPLOADED)
      value.orgMemoDocument = documentHill.orgMemoDocument.url;
    if (documentHill.orgPanDocument.status === iDocumentStages.UPLOADED)
      value.orgPanDocument = documentHill.orgPanDocument.url;

    if (
      documentHill.orgRegistrationDocument.status === iDocumentStages.UPLOADED
    )
      value.orgRegistrationDocument = documentHill.orgRegistrationDocument.url;
    if (
      documentHill.orgBalanceSheetDocument.status === iDocumentStages.UPLOADED
    )
      value.orgBalanceSheetDocument = documentHill.orgBalanceSheetDocument.url;
    if (documentHill.orgIncomeDocument.status === iDocumentStages.UPLOADED)
      value.orgIncomeDocument = documentHill.orgIncomeDocument.url;

    if (documentHill.orgAddressDocument.status === iDocumentStages.UPLOADED)
      value.orgAddressDocument = documentHill.orgAddressDocument.url;

    if (documentHill.orgLossDocument.status === iDocumentStages.UPLOADED)
      value.orgLossDocument = documentHill.orgLossDocument.url;

    console.log("Values...", value);
    value.userType = "ENTITY";

    value.annualIncome = parseInt(value.annualIncome);
    AxiosInstance()
      .put("/profile", value)
      .then(() => {
        setLoading(false);
        window.location.href = "/investorDashboard";
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.response.data.message);
      });
  };
  const entityTypeChange = (data) => {
    errors.industryType = false;
    setValue("industryType", data);
  };
  const dateChange = (_, dateString) => {
    errors.orgRegistrationDate = false;
    setValue("orgRegistrationDate", dateString);
  };

  //   const countryChange = async (value) => {
  //     errors.countryId = false;
  //     setValue("countryId", parseInt(value));
  //     const list = await statesListController(value);
  //     setStateList(list);
  //   };
  const stateChange = (value) => {
    errors.stateId = false;
    setValue("stateId", parseInt(value));
  };
  const bankNameChange = (value) => {
    setValue("bankId", parseInt(value));
  };
  const occupationChange = (value) => {
    setValue("occupation", value);
  };
  const maritalStatusChange = (value) => {
    setValue("maritalStatus", value);
  };
  const accountTypeChange = (value) => {
    setValue("accountType", value);
  };

  async function uploadHandler(key, userId, event) {
    setDocumentHill((prev) => ({
      ...prev,
      [key]: { ...prev[key], status: iDocumentStages.PICKED },
    }));
    console.log(documentHill);
    //upload document
    const result = await uploadProfileDocumentToAWS(
      event.target.files[0],
      userId
    );
    console.log("result", result);
    //if result then set the api result
    if (result !== null && result !== "undefined") {
      setDocumentHill((prev) => ({
        ...prev,
        [key]: {
          ...prev[key],
          status: iDocumentStages.UPLOADED,
          url: result,
        },
      }));
    } else {
      setDocumentHill((prev) => ({
        ...prev,
        [key]: { ...prev[key], status: iDocumentStages.UPLOAD_FAILED },
      }));
    }
  }

  async function handleDocumentNew(event, target) {
    if (event.target.files[0].size > maxFileSize) {
      alert("Maximum File size: 5MB");
      return;
    }
    const userId = localStorage.getItem("userId");
    switch (target) {
      case documentHill.orgMemoDocument.key:
        // set document for retry function
        setOrgMemoDoc(event);
        uploadHandler("orgMemoDocument", userId, event);

        break;
      case documentHill.orgPanDocument.key:
        // set document for retry function
        setorgPanDocument(event);
        uploadHandler("orgPanDocument", userId, event);

        break;
      case documentHill.orgRegistrationDocument.key:
        // set document for retry function
        setorgRegistrationDocument(event);
        uploadHandler("orgRegistrationDocument", userId, event);

        break;
      case documentHill.orgLossDocument.key:
        // set document for retry function
        setorgLossDocument(event);
        uploadHandler("orgLossDocument", userId, event);

        break;
      case documentHill.orgIncomeDocument.key:
        // set document for retry function
        setorgIncomeDocument(event);
        uploadHandler("orgIncomeDocument", userId, event);

        break;
      case documentHill.orgBalanceSheetDocument.key:
        // set document for retry function
        setorgBalanceSheetDocument(event);
        uploadHandler("orgBalanceSheetDocument", userId, event);

        break;
      case documentHill.orgAddressDocument.key:
        // set document for retry function
        setorgAddressDocument(event);
        uploadHandler("orgAddressDocument", userId, event);

        break;

      //   case documentHill.aadharDoc.key:
      //     setaadharDoc(event);
      //     uploadHandler("aadharDoc", userId, event);

      //     break;

      //   case documentHill.cancelledChecqDoc.key:
      //     setcancelledChecqDoc(event);
      //     uploadHandler("cancelledChecqDoc", userId, event);

      //     break;

      //   case documentHill.ITRDoc.key:
      //     setITRDoc(event);
      //     uploadHandler("ITRDoc", userId, event);
      //     break;

      //   case documentHill.bankStatementDoc.key:
      //     setBankStatementDoc(event);
      //     uploadHandler("bankStatementDoc", userId, event);
      //     break;
      //   case documentHill.photoDoc.key:
      //     setPhotoDoc(event);
      //     uploadHandler("photoDoc", userId, event);
      //     break;

      default:
        break;
    }
  }

  function iretryFunction(document) {
    if (documentHill.orgMemoDocument.key === document.key)
      handleDocumentNew(orgMemoDocument, documentHill.orgMemoDocument.key);
    else if (documentHill.orgPanDocument.key === document.key)
      handleDocumentNew(orgPanDocument, document.key);
    else if (documentHill.orgRegistrationDocument.key === document.key)
      handleDocumentNew(orgRegistrationDocument, document.key);
    else if (documentHill.orgLossDocument.key === document.key)
      handleDocumentNew(orgLossDocument, document.key);
    else if (documentHill.orgIncomeDocument.key === document.key)
      handleDocumentNew(orgIncomeDocument, document.key);
    else if (documentHill.orgBalanceSheetDocument.key === document.key)
      handleDocumentNew(orgBalanceSheetDocument, document.key);
    else if (documentHill.orgAddressDocument.key === document.key)
      handleDocumentNew(orgAddressDocument, document.key);

    // if (documentHill.panDoc.key === document.key)
    //   handleDocumentNew(panDoc, documentHill.panDoc.key);
    // else if (documentHill.aadharDoc.key === document.key)
    //   handleDocumentNew(aadharDoc, document.key);
    // else if (documentHill.cancelledChecqDoc.key === document.key)
    //   handleDocumentNew(cancelledChecqDoc, document.key);
    // else if (documentHill.ITRDoc.key === document.key)
    //   handleDocumentNew(ITRDoc, document.key);
    // else if (documentHill.bankStatementDoc.key === document.key)
    //   handleDocumentNew(bankStatementDoc, document.key);
    // else if (documentHill.bankStatementDoc.key === document.key)
    //   handleDocumentNew(bankStatementDoc, document.key);
    // else if (documentHill.photoDoc.key === document.key)
    //   handleDocumentNew(photoDoc, document.key);
  }

  const onNomineeUpdate = (e) => {
    const nomineePayload = nomineeDetails;
    nomineePayload[0] = {
      ...nomineePayload[0],
      [e.target.name]: e.target.value,
    };
    setNomineeDetails(nomineePayload);
  };
  return (
    <form id="companyKycForm" onSubmit={handleSubmit(onSubmit)}>
      <div className={`form-group `}>
        <label htmlFor="nameOfOrganization">
          Entity Name {<span style={{ color: "red" }}>*</span>}
        </label>
        <div className="input-group pb-3">
          <input
            type="text"
            className={`form-control ${
              errors.nameOfOrganization ? "is-invalid" : ""
            }`}
            id="nameOfOrganization"
            disabled={
              profileData.nameOfOrganization && profileData.isUserVerified
            }
            // aria-describedby="emailHelp"
            placeholder=""
            {...register("nameOfOrganization", { required: true })}
          />
          <div className="invalid-feedback">Entity Name is required</div>
        </div>
        <label htmlFor="industryType">
          Entity Type {<span style={{ color: "red" }}>*</span>}
        </label>
        <div className="input-group mb-3">
          <Controller
            name="industryType"
            control={control}
            errors={errors}
            rules={{ required: true }}
            render={({ field: { onChange, value, ref } }) => (
              <Select
                placeholder="Select Entity Type"
                value={getValues("industryType")}
                disabled={
                  profileData.industryType && profileData.isUserVerified
                }
                onChange={entityTypeChange}
                size="large"
                className={`${errors.industryType ? "is-invalid" : ""}`}
                options={industryTypeOptions}
                style={{ width: "100%" }}
              />
            )}
          />

          <div className="invalid-feedback">Entity Type is required</div>
        </div>
        <label htmlFor="orgPan">
          Entity PAN Number {<span style={{ color: "red" }}>*</span>}
        </label>
        <div className="input-group pb-3">
          <input
            disabled={isOrgPanVerified}
            id="orgPan"
            type="text"
            maxlength={10}
            className={`form-control ${errors.orgPan ? "is-invalid" : ""}`}
            {...register("orgPan", {
              required: true,
              minLength: {
                value: 10,
                message: "enter a valid pan number", // JS only: <p>error message</p> TS only support string
              },
              maxLength: {
                value: 10,
                message: "enter a valid pan number", // JS only: <p>error message</p> TS only support string
              },
            })}
          />

          <div className="input-group-append">
            {isOrgPanVerified ? (
              <span className="input-group-text  rounded-0 " id="basic-addon2">
                <i class="fa-solid fa-circle-check text-success py-1 fa-lg"></i>
              </span>
            ) : (
              <button
                disabled={
                  (!getValues("orgPan") && !profileData.orgPan) ||
                  errors?.orgPan?.message
                }
                class="btn btn-outline-primary rounded-0 rounded-right "
                type="button"
                id="button-addon2"
                onClick={() => {
                  setVerifyOrgPanModalState(true);
                }}
              >
                Verify
              </button>
            )}
          </div>
          <div className="invalid-feedback">{errors?.orgPan?.message}</div>
        </div>
        <label htmlFor="orgRegistrationDate">
          Registration or Incorporation Date
        </label>
        <div className="input-group pb-3">
          <Controller
            name="orgRegistrationDate"
            control={control}
            errors={errors}
            rules={{ required: true }}
            render={(props) => (
              <DatePicker
                inputReadOnly
                type="text"
                disabledDate={(current) => {
                  const startDate = moment().subtract(0, "years");
                  return startDate && current.valueOf() > startDate;
                }}
                disabled={
                  profileData.orgRegistrationDate && profileData.isUserVerified
                }
                defaultValue={
                  profileData.orgRegistrationDate
                    ? dayjs(profileData.orgRegistrationDate, "YYYY/MM/DD")
                    : ""
                }
                name="orgRegistrationDate"
                className={`form-control tre_dobdate
                        ${errors.orgRegistrationDate ? " is-invalid" : ""}`}
                onChange={dateChange}
                {...props}
              />
            )}
          />

          <div className="invalid-feedback text-start font-14 mb-1">
            Incorporation Date is required
          </div>
        </div>
        <label htmlFor="addressOfOrganization">Entity Address</label>
        <div className="input-group pb-3">
          <input
            type="text"
            disabled={
              profileData.addressOfOrganization && profileData.isUserVerified
            }
            className={`form-control ${
              errors.addressOfOrganization ? "is-invalid" : ""
            }`}
            id="addressOfOrganization"
            placeholder=""
            {...register("addressOfOrganization")}
          />
          <div className="invalid-feedback">Address is required</div>
        </div>
        <label htmlFor="bankAccountNumber">Bank Account Number</label>
        <div className="input-group pb-3">
          <input
            type="text"
            className={`form-control ${
              errors.bankAccountNumber ? "is-invalid" : ""
            }`}
            id="bankAccountNumber"
            disabled={
              profileData.bankAccountNumber && profileData.isUserVerified
            }
            placeholder=""
            {...register("bankAccountNumber", {
              pattern: {
                value: /^[0-9]*$/i,
                message: "should be a number",
              },
            })}
          />
          <div className="invalid-feedback">
            {errors?.bankAccountNumber?.message}
          </div>
        </div>
        <label htmlFor="bankName">Bank Name</label>
        <div className="input-group pb-3">
          <Controller
            name="bankId"
            control={control}
            errors={errors}
            render={(props) => (
              <Select
                className={`${errors.bankId ? "is-invalid" : ""}`}
                onChange={bankNameChange}
                value={getValues("bankId")}
                disabled={profileData.bankId && profileData.isUserVerified}
                size="large"
                style={{ width: "100%" }}
              >
                {bankList.map((item) => (
                  <Option key={item.bankId} value={item.bankId}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            )}
          />
          <div className="invalid-feedback">Bank Name is required</div>
        </div>
        <label htmlFor="accountType">Account Type</label>
        <div className="input-group pb-3">
          <Controller
            name="accountType"
            control={control}
            errors={errors}
            render={(props) => (
              <Select
                className={`${errors.accountType ? "is-invalid" : ""}`}
                value={getValues("accountType")}
                disabled={profileData.accountType && profileData.isUserVerified}
                onChange={accountTypeChange}
                size="large"
                style={{ width: "100%" }}
              >
                {getEntityBankAccountType()}
              </Select>
            )}
          />

          <div className="invalid-feedback">Account Type is required</div>
        </div>
        <label htmlFor="ifscCode">IFSC Code</label>
        <div className="input-group pb-3">
          <input
            type="text"
            className={`form-control ${errors.IFSCCode ? "is-invalid" : ""}`}
            id="IFSCCode"
            disabled={profileData.IFSCCode && profileData.isUserVerified}
            aria-describedby="IFSCCode"
            placeholder=""
            {...register("IFSCCode")}
          />
        </div>{" "}
        <label htmlFor="UPICode">UPI ID</label>
        <div className="input-group pb-3">
          <input
            type="text"
            className={`form-control ${errors.UPICode ? "is-invalid" : ""}`}
            id="UPICode"
            disabled={
              profileData.UPICode &&
              !AllowedProfileEditStatus.includes(profileData.status)
            }
            aria-describedby="emailHelp"
            placeholder=""
            {...register("UPICode")}
          />
          <div className="invalid-feedback">UPI is required</div>
        </div>
        <label htmlFor="annualIncome">Annual Income/ Profit After Tax</label>
        <div className="input-group pb-3">
          <input
            type="number"
            className={`form-control ${
              errors.annualIncome ? "is-invalid" : ""
            }`}
            id="annualIncome"
            disabled={
              profileData.annualIncome &&
              !AllowedProfileEditStatus.includes(profileData.status)
            }
            // aria-describedby="emailHelp"
            placeholder=""
            {...register("annualIncome", {
              pattern: {
                value: /^\d+$/,
                message: "Please enter a valid income",
              },
            })}
          />
          <div className="invalid-feedback">
            {errors.annualIncome && (
              <span>{errors?.annualIncome?.message}</span>
            )}
          </div>
        </div>
        {/* 
        <label htmlFor="pan">
          PAN Number {<span style={{ color: "red" }}>*</span>}
        </label>
        <div className="input-group pb-3">
          <input
            disabled={isPanVerified}
            id="pan"
            type="text"
            maxlength={10}
            className={`form-control ${errors.pan ? "is-invalid" : ""}`}
            {...register("pan", {
              minLength: {
                value: 10,
                message: "enter a valid pan number", // JS only: <p>error message</p> TS only support string
              },
              maxLength: {
                value: 10,
                message: "enter a valid pan number", // JS only: <p>error message</p> TS only support string
              },
            })}
          />

          <div className="input-group-append">
            {isPanVerified ? (
              <span className="input-group-text  rounded-0 " id="basic-addon2">
                <i class="fa-solid fa-circle-check text-success py-1 fa-lg"></i>
              </span>
            ) : (
              <button
                disabled={!getValues("pan") || errors?.pan?.message}
                class="btn btn-outline-primary rounded-0 rounded-right "
                type="button"
                id="button-addon2"
                onClick={() => {
                  setVerifyPanModalState(true);
                }}
              >
                Verify
              </button>
            )}
          </div>
          <div className="invalid-feedback">{errors?.pan?.message}</div>
        </div>
        <VerifyPanModal
          setActive={setVerifyPanModalState}
          active={verifyPanModalState}
          setPanVerified={setIsPanVerified}
          pan={getValues("pan")}
        ></VerifyPanModal>
        <label htmlFor="aadhar">Aadhaar Number</label>
        <div className="input-group pb-3">
          <input
            type="text"
            disabled={isAadhaarVerified}
            id="aadhar"
            maxlength="12"
            className={`form-control ${errors.aadhar ? "is-invalid" : ""}`}
            {...register("aadhar", {
              pattern: {
                value: /^[0-9]*$/i,
                message: "should be a number",
              },
              minLength: {
                value: 12,
                message: "enter a valid aadhar number", // JS only: <p>error message</p> TS only support string
              },
            })}
          />{" "}
          <div className="input-group-append">
            {isAadhaarVerified ? (
              <span className="input-group-text  rounded-0 " id="basic-addon2">
                <i class="fa-solid fa-circle-check text-success py-1 fa-lg"></i>
              </span>
            ) : (
              <button
                disabled={!getValues("aadhar") || errors?.aadhar?.message}
                class="btn btn-outline-primary rounded-0 rounded-right "
                type="button"
                id="button-addon2"
                onClick={() => {
                  setVerifyAadhaarModalState(true);
                }}
              >
                Verify
              </button>
            )}
          </div>
          <div className="invalid-feedback">{errors?.aadhar?.message}</div>
        </div>
        <VerifyAadharModal
          setActive={setVerifyAadhaarModalState}
          active={verifyAadhaarModalState}
          setPanVerified={setIsAadhaarVerified}
          aadhar={getValues("aadhar")}
        ></VerifyAadharModal>
        <label htmlFor="addressOfOrganization">Current Address</label>
        <div className="input-group pb-3">
          <input
            type="text"
            disabled={profileData.addressOfOrganization && profileData.isUserVerified}
            className={`form-control ${errors.addressOfOrganization ? "is-invalid" : ""}`}
            id="addressOfOrganization"
            placeholder=""
            {...register("addressOfOrganization")}
          />
          <div className="invalid-feedback">Address is required</div>
        </div>
        <label htmlFor="occupation">Occupation</label>
        <div className="input-group pb-3">
          <Controller
            name="occupation"
            control={control}
            errors={errors}
            render={(props) => (
              <Select
                className={`${errors.occupation ? "is-invalid" : ""}`}
                onChange={occupationChange}
                value={getValues("occupation")}
                disabled={
                  profileData.occupation &&
                  !AllowedProfileEditStatus.includes(profileData.status)
                }
                size="large"
                style={{ width: "100%" }}
              >
                {occupationOptions.map((item) => (
                  <Option key={item.occupationId} value={item.occupationId}>
                    {item.occupation}
                  </Option>
                ))}
              </Select>
            )}
          />
          <div className="invalid-feedback"> {errors?.occupation?.message}</div>
        </div>
        <label htmlFor="nameOfOrganization">Company Name</label>
        <div className="input-group pb-3">
          <input
            type="text"
            className={`form-control ${
              errors.nameOfOrganization ? "is-invalid" : ""
            }`}
            id="nameOfOrganization"
            disabled={
              profileData.nameOfOrganization && profileData.isUserVerified
            }
            // aria-describedby="emailHelp"
            placeholder=""
            {...register("nameOfOrganization")}
          />
          <div className="invalid-feedback">Employer Name is required</div>
        </div>
        <label htmlFor="industryType">Industry Type</label>
        <div className="input-group pb-3">
          <input
            type="text"
            className={`form-control ${
              errors.industryType ? "is-invalid" : ""
            }`}
            id="industryType"
            disabled={profileData.industryType && profileData.isUserVerified}
            // aria-describedby="emailHelp"
            placeholder=""
            {...register("industryType")}
          />
          <div className="invalid-feedback">Industry Type is required</div>
        </div>
        <label htmlFor="jobTitle">Job Title</label>
        <div className="input-group pb-3">
          <input
            type="text"
            className={`form-control ${errors.jobTitle ? "is-invalid" : ""}`}
            id="jobTitle"
            disabled={profileData.jobTitle && profileData.isUserVerified}
            // aria-describedby="emailHelp"
            placeholder=""
            {...register("jobTitle")}
          />
          <div className="invalid-feedback">Job Title is required</div>
        </div>
        <label htmlFor="occupation">Maritial Status</label>
        <div className="input-group pb-3">
          <Controller
            name="maritalStatus"
            control={control}
            errors={errors}
            render={(props) => (
              <Select
                className={`${errors.maritalStatus ? "is-invalid" : ""}`}
                onChange={maritalStatusChange}
                value={getValues("maritalStatus")}
                disabled={
                  profileData.maritalStatus &&
                  !AllowedProfileEditStatus.includes(profileData.status)
                }
                size="large"
                style={{ width: "100%" }}
              >
                {maritialStatusOptions.map((item) => (
                  <Option
                    key={item.maritalStatusId}
                    value={item.maritalStatusId}
                  >
                    {item.maritalStatus}
                  </Option>
                ))}
              </Select>
            )}
          />

          <div className="invalid-feedback">
            {" "}
            {errors?.maritalStatus?.message}
          </div>
        </div>
        <div className="grid-form">
          <div>
            <label htmlFor="city">City</label>
            <div className="input-group pb-3">
              <input
                disabled={profileData.city && profileData.isUserVerified}
                type="text"
                className={`form-control ${errors.city ? "is-invalid" : ""}`}
                id="city"
                placeholder=""
                {...register("city", {
                  pattern: {
                    value:
                      /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/i,
                    message: "should not be a number",
                  },
                })}
              />
              <div className="invalid-feedback"> {errors?.city?.message}</div>
            </div>
          </div>
          <div>
            <label htmlFor="countryId">Country</label>
            <div className="input-group pb-3">
              <Controller
                name="countryId"
                control={control}
                errors={errors}
                render={(props) => (
                  <Select
                    className={` ${errors.countryId ? "is-invalid" : ""}`}
                    placeholder="Select Country"
                    value={getValues("countryId")}
                    disabled={
                      profileData.countryId && profileData.isUserVerified
                    }
                    onChange={countryChange}
                    size="large"
                    style={{ width: "100%" }}
                  >
                    {countries.map((item) => (
                      <Option key={item.countryId} value={item.countryId}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                )}
              />
              <div className="invalid-feedback">Country is required</div>
            </div>
          </div>
        </div>
        <div className="grid-form">
          <div>
            <label htmlFor="stateId">State</label>
            <div className="input-group pb-3">
              <Controller
                name="stateId"
                control={control}
                errors={errors}
                render={(props) => (
                  <Select
                    className={` ${errors.stateId ? "is-invalid" : ""}`}
                    placeholder="Select State"
                    onChange={stateChange}
                    value={getValues("stateId")}
                    disabled={profileData.stateId && profileData.isUserVerified}
                    size="large"
                    style={{ width: "100%" }}
                  >
                    {stateList.map((item) => (
                      <Option key={item.stateId} value={item.stateId}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                )}
              />
              <div className="invalid-feedback">State is required</div>
            </div>
          </div>

          <div>
            <label htmlFor="pincode">Pincode</label>
            <div className="input-group pb-3">
              <input
                type="text"
                maxlength="6"
                disabled={profileData.pinCode && profileData.isUserVerified}
                className={`form-control ${errors.pinCode ? "is-invalid" : ""}`}
                id="pinCode"
                placeholder=""
                {...register("pinCode", {
                  pattern: {
                    value: /^[0-9]*$/i,
                    message: "should be a number",
                  },
                })}
              />
              <div className="invalid-feedback">{errors?.pinCode?.message}</div>
            </div>
          </div>
        </div>
        <label htmlFor="bankAccountNumber">Bank Account Number</label>
        <div className="input-group pb-3">
          <input
            type="text"
            className={`form-control ${
              errors.bankAccountNumber ? "is-invalid" : ""
            }`}
            id="bankAccountNumber"
            disabled={
              profileData.bankAccountNumber && profileData.isUserVerified
            }
            placeholder=""
            {...register("bankAccountNumber", {
              pattern: {
                value: /^[0-9]*$/i,
                message: "should be a number",
              },
            })}
          />
          <div className="invalid-feedback">
            {errors?.bankAccountNumber?.message}
          </div>
        </div>
        <label htmlFor="bankName">Bank Name</label>
        <div className="input-group pb-3">
          <Controller
            name="bankId"
            control={control}
            errors={errors}
            render={(props) => (
              <Select
                className={`${errors.bankId ? "is-invalid" : ""}`}
                onChange={bankNameChange}
                value={getValues("bankId")}
                disabled={profileData.bankId && profileData.isUserVerified}
                size="large"
                style={{ width: "100%" }}
              >
                {bankList.map((item) => (
                  <Option key={item.bankId} value={item.bankId}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            )}
          />
          <div className="invalid-feedback">Bank Name is required</div>
        </div>
        <label htmlFor="accountType">Account Type</label>
        <div className="input-group pb-3">
          <Controller
            name="accountType"
            control={control}
            errors={errors}
            render={(props) => (
              <Select
                className={`${errors.accountType ? "is-invalid" : ""}`}
                value={getValues("accountType")}
                disabled={profileData.accountType && profileData.isUserVerified}
                onChange={accountTypeChange}
                size="large"
                style={{ width: "100%" }}
              >
                {getBankAccountType()}
              </Select>
            )}
          />

          <div className="invalid-feedback">Account Type is required</div>
        </div>
        <label htmlFor="ifscCode">IFSC Code</label>
        <div className="input-group pb-3">
          <input
            type="text"
            className={`form-control ${errors.IFSCCode ? "is-invalid" : ""}`}
            id="IFSCCode"
            disabled={profileData.IFSCCode && profileData.isUserVerified}
            aria-describedby="IFSCCode"
            placeholder=""
            {...register("IFSCCode")}
          />
        </div>{" "}
        <label htmlFor="UPICode">UPI ID</label>
        <div className="input-group pb-3">
          <input
            type="text"
            className={`form-control ${errors.UPICode ? "is-invalid" : ""}`}
            id="UPICode"
            disabled={
              profileData.UPICode &&
              !AllowedProfileEditStatus.includes(profileData.status)
            }
            aria-describedby="emailHelp"
            placeholder=""
            {...register("UPICode")}
          />
          <div className="invalid-feedback">UPI is required</div>
        </div>
        <label htmlFor="EIANumber">EIA Number</label>
        <div className="input-group pb-3">
          <input
            type="text"
            className={`form-control ${errors.EIANumber ? "is-invalid" : ""}`}
            id="EIANumber"
            disabled={
              profileData.EIANumber &&
              !AllowedProfileEditStatus.includes(profileData.status)
            }
            // aria-describedby="emailHelp"
            placeholder=""
            {...register("EIANumber")}
          />
          <div className="invalid-feedback">EIA Number is required</div>
        </div>
        <label htmlFor="annualIncome">Annual Income</label>
        <div className="input-group pb-3">
          <input
            type="number"
            className={`form-control ${
              errors.annualIncome ? "is-invalid" : ""
            }`}
            id="annualIncome"
            disabled={
              profileData.annualIncome &&
              !AllowedProfileEditStatus.includes(profileData.status)
            }
            // aria-describedby="emailHelp"
            placeholder=""
            {...register("annualIncome", {
              pattern: {
                value: /^\d+$/,
                message: "Please enter a valid income",
              },
            })}
          />
          <div className="invalid-feedback">
            {errors.annualIncome && (
              <span>{errors?.annualIncome?.message}</span>
            )}
          </div>
        </div>
        <label htmlFor="education">Education</label>
        <div className="input-group pb-3">
          <input
            type="text"
            className={`form-control ${errors.education ? "is-invalid" : ""}`}
            id="education"
            disabled={
              profileData.education &&
              !AllowedProfileEditStatus.includes(profileData.status)
            }
            // aria-describedby="emailHelp"
            placeholder=""
            {...register("education")}
          />
          <div className="invalid-feedback">Education is required</div>
        </div>
        */}
      </div>
      <h3 className="pt-2">Authorized Signatory</h3>
      {/* <p style={{ color: "grey" }}>
        Upload only jpg, png, pdf files. Max size 5 MB.
      </p> */}
      <Divider className="mt-0" />
      <label htmlFor="firstName">
        First Name {<span style={{ color: "red" }}>*</span>}
      </label>
      <div className="input-group pb-3">
        <input
          type="text"
          className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
          id="UPICode"
          disabled={
            profileData.firstName &&
            !AllowedProfileEditStatus.includes(profileData.status)
          }
          aria-describedby="firstName"
          placeholder=""
          {...register("firstName", {
            required: {
              value: true,
              message: "Enter First Name",
            },
          })}
        />
        <div className="invalid-feedback">First Name is required</div>
      </div>
      <label htmlFor="lastName">
        Last Name {<span style={{ color: "red" }}>*</span>}
      </label>
      <div className="input-group pb-3">
        <input
          type="text"
          className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
          id="lastName"
          disabled={
            profileData.lastName &&
            !AllowedProfileEditStatus.includes(profileData.status)
          }
          aria-describedby="lastName"
          placeholder=""
          {...register("lastName", {
            required: {
              value: true,
              message: "Enter Last Name", // JS only: <p>error message</p> TS only support string
            },
          })}
        />
        <div className="invalid-feedback">Last Name is required</div>
      </div>
      <label htmlFor="pan">
        PAN Number {<span style={{ color: "red" }}>*</span>}
      </label>
      <div className="input-group pb-3">
        <input
          disabled={isPanVerified}
          id="pan"
          type="text"
          maxlength={10}
          className={`form-control ${errors.pan ? "is-invalid" : ""}`}
          {...register("pan", {
            minLength: {
              value: 10,
              message: "enter a valid pan number", // JS only: <p>error message</p> TS only support string
            },
            maxLength: {
              value: 10,
              message: "enter a valid pan number", // JS only: <p>error message</p> TS only support string
            },
          })}
        />

        <div className="input-group-append">
          {isPanVerified ? (
            <span className="input-group-text  rounded-0 " id="basic-addon2">
              <i class="fa-solid fa-circle-check text-success py-1 fa-lg"></i>
            </span>
          ) : (
            <button
              disabled={
                (!getValues("pan") && !profileData.pan) || errors?.pan?.message
              }
              class="btn btn-outline-primary rounded-0 rounded-right "
              type="button"
              id="button-addon2"
              onClick={() => {
                setVerifyPanModalState(true);
              }}
            >
              Verify
            </button>
          )}
        </div>
        <div className="invalid-feedback">{errors?.pan?.message}</div>
      </div>
      <VerifyPanModal
        setActive={setVerifyPanModalState}
        active={verifyPanModalState}
        setPanVerified={setIsPanVerified}
        idName={"PAN"}
        pan={getValues("pan")}
      ></VerifyPanModal>
      <VerifyPanModal
        setActive={setVerifyOrgPanModalState}
        active={verifyOrgPanModalState}
        setPanVerified={setIsOrgPanVerified}
        idName={"ORG_PAN"}
        pan={getValues("orgPan")}
      ></VerifyPanModal>
      <h3 className="pt-2">Document Upload</h3>
      <p style={{ color: "grey" }}>
        Upload only jpg, png, pdf files. Max size 5 MB.
      </p>
      <Divider className="mt-0" />
      {!profileData.orgMemoDocument && (
        <div className="mb-3 mt-2">
          <label htmlFor="formFile" className="form-label">
            Upload Copy of Memorandom/ AOA{" "}
            <>{documentWidget(documentHill.orgMemoDocument, iretryFunction)}</>
          </label>
          <input
            className="form-control"
            type="file"
            id="orgMemoDocument"
            accept={documentAccpetedTypes}
            onChange={(event) => {
              handleDocumentNew(event, documentHill.orgMemoDocument.key);
            }}
          />{" "}
        </div>
      )}
      {!profileData.orgPanDocument && (
        <div className="mb-3 mt-2">
          <label htmlFor="formFile" className="form-label">
            Upload Entity PAN{" "}
            <>{documentWidget(documentHill.orgPanDocument, iretryFunction)}</>
          </label>
          <input
            className={`form-control ${
              errors.orgPanDocument ? "is-invalid" : ""
            }`}
            type="file"
            id="orgPanDocument"
            accept={documentAccpetedTypes}
            onChange={(event) => {
              handleDocumentNew(event, documentHill.orgPanDocument.key);
            }}
          />{" "}
        </div>
      )}

      {!profileData.orgRegistrationDocument && (
        <div className="mb-3">
          <label htmlFor="formFile" className="form-label">
            Upload Registraion Certificate{" "}
            <>
              {documentWidget(
                documentHill.orgRegistrationDocument,
                iretryFunction
              )}
            </>
          </label>
          <input
            className="form-control"
            type="file"
            id="orgRegistrationDocument"
            accept={documentAccpetedTypes}
            onChange={(event) => {
              handleDocumentNew(
                event,
                documentHill.orgRegistrationDocument.key
              );
            }}
          />{" "}
        </div>
      )}
      {!profileData.orgAddressDocument && (
        <div className="mb-3">
          <label htmlFor="formFile" className="form-label">
            Upload Address Proof{" "}
            <>
              {documentWidget(documentHill.orgAddressDocument, iretryFunction)}
            </>
          </label>
          <input
            className="form-control"
            type="file"
            id="orgAddressDocument"
            accept={documentAccpetedTypes}
            onChange={(event) => {
              handleDocumentNew(event, documentHill.orgAddressDocument.key);
            }}
          />{" "}
        </div>
      )}
      {!profileData.orgIncomeDocument && (
        <div className="mb-3">
          <label htmlFor="formFile" className="form-label">
            Upload Latest ITR Copy{" "}
            <>
              {documentWidget(documentHill.orgIncomeDocument, iretryFunction)}
            </>
          </label>
          <input
            className="form-control"
            type="file"
            id="orgIncomeDocument"
            accept={documentAccpetedTypes}
            onChange={(event) => {
              handleDocumentNew(event, documentHill.orgIncomeDocument.key);
            }}
          />{" "}
        </div>
      )}
      {!profileData.orgLossDocument && (
        <div className="mb-3">
          <label htmlFor="formFile" className="form-label">
            Upload Profit & Loss Statement{" "}
            <>{documentWidget(documentHill.orgLossDocument, iretryFunction)}</>
          </label>
          <input
            className="form-control"
            type="file"
            accept={documentAccpetedTypes}
            id="orgLossDocument"
            onChange={(event) => {
              handleDocumentNew(event, documentHill.orgLossDocument.key);
            }}
          />{" "}
        </div>
      )}
      {!profileData.orgBalanceSheetDocument && (
        <div className="mb-3">
          <label htmlFor="formFile" className="form-label">
            Upload Balance Sheet{" "}
            <>
              {documentWidget(
                documentHill.orgBalanceSheetDocument,
                iretryFunction
              )}
            </>
          </label>
          <input
            className="form-control"
            type="file"
            accept={documentAccpetedTypes}
            id="orgBalanceSheetDocument"
            onChange={(event) => {
              handleDocumentNew(
                event,
                documentHill.orgBalanceSheetDocument.key
              );
            }}
          />{" "}
        </div>
      )}
      <button
        form="companyKycForm"
        className="normal-button-investor mb-5 px-3 py-2"
      >
        {loading ? "Loading" : "Submit"}
      </button>
    </form>
  );
}
